module.exports = __webpack_public_path__ + "static/media/bars-solid.ba42d945.svg";